import React from 'react';
import { connect } from 'react-redux';
import Config from '../config';
import { Button } from 'antd';
import { socialLogin } from '../actions/socialLogin';
import * as R from 'ramda';

class FBLoginButton extends React.Component {

    loadFbLoginApi() {

        window.fbAsyncInit = function () {
            window.FB.init({
                appId: `${Config.thirdPartySignIn.facebook}`,
                cookie: true,  // enable cookies to allow the server to access
                // the session
                xfbml: true,  // parse social plugins on this page
                version: 'v7.0'
            });
        };
        // Load the SDK asynchronously
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }

    componentDidMount() {
        this.loadFbLoginApi();
    }

    componentDidUpdate(prevProps) {
        const prevSessionToken = prevProps.socialLoginResponse.data.sessionToken;
        const sessionToken = this.props.socialLoginResponse.data.sessionToken;
        const refreshToken = this.props.socialLoginResponse.data.refreshToken;
        // 當 sessionToken 出現 && 為 fb 登入的時候
        if (R.isNil(prevSessionToken) &&
            !R.isNil(sessionToken) &&
            R.includes('fb_', this.props.socialLoginResponse.data.user.uid)) {

            if (this.props.socialLoginResponse.data.emailVerified) {
                window.location.assign(`${Config.thirdPartySignIn.redirectUrl}?status=SUCCESS&token=${sessionToken}&refresh=${refreshToken}`);
            } else {
                window.location.assign(`${Config.thirdPartySignIn.redirectUrl}?status=EMAILNOTBIND&msg=emailNotVerified`);
            }

        }

    }

    handleFBLogin = () => {
        window.FB.login(function (response) {
            if (response.authResponse) {

                let obj = {
                    provider: 'Facebook',
                    token: response.authResponse.accessToken
                }
                this.props.socialLogin(obj);

            } else {
                window.location.assign(`${Config.thirdPartySignIn.redirectUrl}?status=FAIL&msg=FBLOGINFAIL`);
                Config.log('User cancelled login or did not fully authorize.');
            }
        }.bind(this));
    }

    render() {
        return (
            <div>
                <Button
                    className="fb"
                    onClick={this.handleFBLogin}
                >

                </Button>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    socialLoginResponse: state.socialLogin.submitResponse,
    isSocialSubmitting: state.socialLogin.submitResponse.isSubmitting,
    isSocialLogged: state.socialLogin.isLogged,
});

const mapDispatchToProps = {
    socialLogin
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FBLoginButton);